import { Dispatch } from "redux";
import api, { wsURL } from "../../api/api";
import {
    setcourseImageGenerate,
    setloading,
    seterror,
    resetCourseImageGenerate,
} from "../reducers/courseImageGenerateReducer";

const courseImageGenerateDtl = (data: any) => async (
    dispatch: Dispatch
) => {
    dispatch(setloading(true));
    try {
        const result = await api.post(`/ai/generate_course_image/`,
            data,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                // AI image generation takes ~37s; the 30s instance default aborted the
                // request mid-flight and the retry interceptor re-fired the generation.
                timeout: 60000,
            });

        if (result) {
            dispatch(setloading(false));
            dispatch(setcourseImageGenerate(result.data));
        }
    } catch (error: any) {
        dispatch(seterror(error.response?.data?.message || "Error generating image"));
        dispatch(setloading(false));
    }
};

export { courseImageGenerateDtl, resetCourseImageGenerate };